import type { RefObject } from 'react';
import React from 'react';

import type { WebinarInfo } from '@/api/webinar';

import * as S from './WebinarInfoSection.style';

type WebinarInfoSectionProps = {
  refObject: RefObject<HTMLElement>;
  info: WebinarInfo;
};

const WebinarInfoSection = ({ refObject, info }: WebinarInfoSectionProps) => {
  return (
    <S.Section ref={refObject}>
      <S.Title>{info.title}</S.Title>
      <S.Descriptions>
        {info.descriptions.map((description, idx) => (
          <S.Description key={'웨비나 소개' + idx}>{description}</S.Description>
        ))}
      </S.Descriptions>
    </S.Section>
  );
};
export default WebinarInfoSection;
